import { selectDisplayColor, type SelectColor } from '@couplespace/core/databases';

import type { BlockPropertyRecord, DatabaseColumnDefinition } from './types';

export function colorColumns(columns: DatabaseColumnDefinition[]): DatabaseColumnDefinition[] {
  return columns.filter((column) => column.type === 'select' || column.type === 'multi_select');
}

/** Option color for a calendar or timeline item. Multi-select uses the first option. */
export function rowOptionColor(
  properties: BlockPropertyRecord[] | undefined,
  column: DatabaseColumnDefinition | undefined,
): SelectColor | null {
  if (!column) {
    return null;
  }
  const value = properties?.find((property) => property.propertyId === column.id)?.value;
  if (!value || typeof value !== 'object' || !('t' in value)) {
    return null;
  }
  const payload = value as { t?: unknown; v?: unknown };
  if (payload.t === 'select') {
    return selectDisplayColor(column.config, payload.v == null ? null : String(payload.v));
  }
  if (payload.t === 'multi_select' && Array.isArray(payload.v)) {
    const first = payload.v.find((item) => item != null && String(item).length > 0);
    if (first == null) {
      return null;
    }
    return selectDisplayColor(column.config, String(first));
  }
  return null;
}

export function placedItemColorClass(color: SelectColor | null): string {
  return color ? `cs-db-select-chip-${color}` : '';
}
